export default "__VITE_ASSET__CJShta9W__"